(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8491],{

/***/ 76275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useErrorPage; }
/* harmony export */ });
/* harmony import */ var _useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18060);

var useErrorPage = (0,_useLanguageDependentDataSsr_hook__WEBPACK_IMPORTED_MODULE_0__/* .useLanguageDependentDataSSr */ .Y)("error-page");


/***/ }),

/***/ 265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useErrorPage_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76275);
/* harmony import */ var _components_shared_meta_tags_resolver_meta_tags_resolver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66743);
/* harmony import */ var _components_shared_text_section_text_section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29209);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ErrorPage = function() {
    var data = (0,_api_hooks_useErrorPage_hook__WEBPACK_IMPORTED_MODULE_2__/* .useErrorPage */ .v)();
    if (data) {
        var ref, ref1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_meta_tags_resolver_meta_tags_resolver__WEBPACK_IMPORTED_MODULE_3__/* .MetaTagsResolver */ .H, {
                    tags: data.meta
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_text_section_text_section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: (ref = data === null || data === void 0 ? void 0 : data.title) !== null && ref !== void 0 ? ref : "",
                    description: (ref1 = data === null || data === void 0 ? void 0 : data.description) !== null && ref1 !== void 0 ? ref1 : ""
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
};
ErrorPage.dataHooks = [
    _api_hooks_useErrorPage_hook__WEBPACK_IMPORTED_MODULE_2__/* .useErrorPage */ .v
].concat(_toConsumableArray(_components_shared_meta_tags_resolver_meta_tags_resolver__WEBPACK_IMPORTED_MODULE_3__/* .MetaTagsResolver.dataHooks */ .H.dataHooks));
/* harmony default export */ __webpack_exports__["Z"] = (ErrorPage);


/***/ }),

/***/ 18491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ TypoPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@react-pdf-viewer/core/lib/index.js
var lib = __webpack_require__(54141);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/useErrorPage.hook.ts
var useErrorPage_hook = __webpack_require__(76275);
// EXTERNAL MODULE: ./src/api/hooks/useTypoContent.hook.ts
var useTypoContent_hook = __webpack_require__(80612);
// EXTERNAL MODULE: ./src/api/services/typo.service.tsx + 53 modules
var typo_service = __webpack_require__(55584);
// EXTERNAL MODULE: ./src/components/_shared/contact-form/contact-form.tsx
var contact_form = __webpack_require__(71157);
// EXTERNAL MODULE: ./src/components/_shared/footer/footer.tsx + 8 modules
var footer = __webpack_require__(46051);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/article-page/article-page-temp-header/article-page-temp-header.tsx + 4 modules
var article_page_temp_header = __webpack_require__(392);
// EXTERNAL MODULE: ./src/components/register/register-form/register-form-light.tsx + 1 modules
var register_form_light = __webpack_require__(17750);
// EXTERNAL MODULE: ./src/components/typo/progress_reader/progress_reader.module.scss
var progress_reader_module = __webpack_require__(46076);
var progress_reader_module_default = /*#__PURE__*/__webpack_require__.n(progress_reader_module);
;// CONCATENATED MODULE: ./src/components/typo/progress_reader/progress_reader.tsx





var ProgressReader = function(props) {
    var items = props.items, maxWidth = props.maxWidth, withoutBar = props.withoutBar;
    if (!items) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var typoService = new typo_service/* TypoService */.$((0,useTypoContent_hook/* useTypoContent */.f)());
    var ref = (0,react.useState)(0), readingProgress = ref[0], setReadingProgress = ref[1];
    var targetRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var calculateReadingProgress = function() {
            if (!targetRef.current) return;
            var targetElement = targetRef.current;
            var targetRect = targetElement.getBoundingClientRect();
            var targetTop = targetRect.top;
            var targetBottom = targetRect.bottom;
            var isInViewport = targetTop <= 0 && targetBottom >= 0;
            var progress = Math.floor(Math.abs(targetTop) / targetElement.offsetHeight * 100);
            if (isInViewport) {
                if (progress <= 0) {
                    progress = 1;
                } else if (progress > 100) {
                    progress = 100;
                }
                setReadingProgress(progress);
            } else if (targetTop >= 0) {
                setReadingProgress(0);
            } else if (targetBottom < 0) {
                setReadingProgress(100);
            }
        };
        var scrollListener = function() {
            calculateReadingProgress();
        };
        document.addEventListener("scroll", scrollListener);
        return function() {
            document.removeEventListener("scroll", scrollListener);
        };
    }, []);
    var progressBarStyles = {
        width: "".concat(readingProgress, "%")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (progress_reader_module_default())["reading-progress-container"],
        children: [
            !withoutBar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (progress_reader_module_default())["reading-progress"],
                style: progressBarStyles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (progress_reader_module_default())["width-" + maxWidth],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: targetRef,
                    className: (progress_reader_module_default()).content,
                    children: Object.keys(items).map(function(key) {
                        var element = items[key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: typoService.createContentElement(element)
                        }, key);
                    })
                })
            })
        ]
    });
};
ProgressReader.defaultProps = {};


// EXTERNAL MODULE: ./src/pages/_app.tsx + 13 modules
var _app = __webpack_require__(86815);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/article-page-types.tsx
var article_page_types = __webpack_require__(88092);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
// EXTERNAL MODULE: ./src/views/error-page/error-page.tsx
var error_page = __webpack_require__(265);
// EXTERNAL MODULE: ./src/views/typo-page/typo-page.module.scss
var typo_page_module = __webpack_require__(10995);
var typo_page_module_default = /*#__PURE__*/__webpack_require__.n(typo_page_module);
;// CONCATENATED MODULE: ./src/views/typo-page/typo-page.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}























var TypoPage = function() {
    var setProgressReaderCollect = function setProgressReaderCollect(assign) {
        progressReaderCollect = assign;
    };
    var setProgressReader = function setProgressReader(assign) {
        progressReader = assign;
    };
    var setProgressReaderItems = function setProgressReaderItems(assign) {
        progressReaderItems = assign;
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var router = (0,client_router.useRouter)();
    var ref29 = (0,react.useState)(false), initComplete = ref29[0], setInitComplete = ref29[1];
    var ref30 = (0,react.useState)(false), loginAuthDone = ref30[0], setLoginAuthDone = ref30[1];
    var ref31 = (0,react.useState)(true), loading = ref31[0], setLoading = ref31[1];
    var ref32 = (0,react.useState)(null), errorData = ref32[0], setErrorData = ref32[1];
    var pending = (0,hooks/* useAppSelector */.C)(function(state) {
        return state.authentification.pending;
    });
    var typoContent = (0,useTypoContent_hook/* useTypoContent */.f)();
    (0,react.useEffect)(function() {
        if (pending && !loginAuthDone) {
            setLoginAuthDone(true);
        }
        // Reload page and its content on login
        if (loginAuthDone && redux/* store.getState */.T8.getState().authentification.jwt) {
            var pathname = router.pathname, asPath = router.asPath, query = router.query;
            var lang = router.locale ? router.locale.toLowerCase() : "en";
            router.push({
                pathname: pathname,
                query: query
            }, asPath, {
                locale: lang
            });
        }
        if (!initComplete) {
            setInitComplete(true);
        }
    }, [
        pending,
        redux/* store.getState */.T8.getState().authentification.jwt
    ]);
    // Unset errorData on language change
    (0,react.useEffect)(function() {
        if (errorData) {
            setErrorData(null);
        }
    }, [
        router.locale,
        router.query
    ]);
    // Errorcode handling (get content from Typo3 error pages)
    var getTypoPageData = function(page) {
        (0,useTypoContent_hook/* getTypoData */.n)(router.locale, {
            typoPage: [
                page
            ]
        }).then(function(resp) {
            if (resp && typeof resp != "number") {
                setErrorData(resp);
                setLoading(false);
            }
        }).catch();
    };
    if (!errorData && (!typoContent || typeof typoContent === "number" || !typoContent.id)) {
        if (typoContent === 403) {
            getTypoPageData("403");
        } else {
            getTypoPageData("404");
        }
    }
    var data = typoContent && typeof typoContent !== "number" ? typoContent : errorData;
    var typoService = new typo_service/* TypoService */.$(data);
    var ref33;
    var pageContent = (ref33 = typoService.getPageContent()) !== null && ref33 !== void 0 ? ref33 : [];
    var type = article_page_types/* ArticlePageTypes.ARTICLE_PAGE */.W.ARTICLE_PAGE;
    var localizations = typoService.getLocalizations();
    var firstContentElement = pageContent[0];
    var stageElement = typoService.createStageElement(firstContentElement);
    if (typeof typoContent !== "number" && loading) {
        setLoading(false);
    }
    // Page background (default: white, inverted: black)
    var inverted = data && data.creatokia && data.creatokia.style ? data.creatokia.style === "inverted" : false;
    // Language switcher
    var nextLocalizations = [];
    if (typeof localizations !== "boolean") {
        var currentLocale = !router.locale || router.locale === "catchAll" ? "en" : router.locale;
        localizations.map(function(lang) {
            // Removes the active language from the select menu
            if (currentLocale == lang.twoLetterIsoCode) {
                return true;
            }
            if (nextLocalizations) {
                // Adjustment because EN has a different ID in Strapi
                var id = lang.twoLetterIsoCode === "en" ? 34 : lang.languageId;
                nextLocalizations.push({
                    id: id,
                    locale: lang.twoLetterIsoCode
                });
            }
        });
    }
    // MetaTagsResolver conversion
    var meta = data && typeof data != "number" && data.meta ? data.meta : {};
    var newsCE = typoService.getNewsContent();
    var newsTitle = (newsCE === null || newsCE === void 0 ? void 0 : (ref = newsCE.news) === null || ref === void 0 ? void 0 : (ref1 = ref.detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metaData) === null || ref2 === void 0 ? void 0 : ref2.alternativeTitle) != "" ? newsCE === null || newsCE === void 0 ? void 0 : (ref3 = newsCE.news) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.detail) === null || ref4 === void 0 ? void 0 : ref4.title : newsCE === null || newsCE === void 0 ? void 0 : (ref5 = newsCE.news) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.detail) === null || ref6 === void 0 ? void 0 : ref6.title;
    var newsDesc = (newsCE === null || newsCE === void 0 ? void 0 : (ref7 = newsCE.news) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.detail) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.metaData) === null || ref9 === void 0 ? void 0 : ref9.description) != "" ? newsCE === null || newsCE === void 0 ? void 0 : (ref10 = newsCE.news) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.detail) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.metaData) === null || ref12 === void 0 ? void 0 : ref12.description : newsCE === null || newsCE === void 0 ? void 0 : (ref13 = newsCE.news) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.detail) === null || ref14 === void 0 ? void 0 : ref14.teaser;
    var newsImages = newsCE === null || newsCE === void 0 ? void 0 : (ref15 = newsCE.news) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.detail) === null || ref16 === void 0 ? void 0 : ref16.falRelatedFiles;
    var metaImage = newsImages ? (ref17 = newsImages[0]) === null || ref17 === void 0 ? void 0 : ref17.images.defaultImage : undefined;
    var ref34;
    var chosenImage = (ref34 = metaImage === null || metaImage === void 0 ? void 0 : metaImage.publicUrl) !== null && ref34 !== void 0 ? ref34 : (ref18 = meta.ogImage) === null || ref18 === void 0 ? void 0 : ref18.publicUrl;
    var metaOgImage = {
        url: chosenImage !== null && chosenImage !== void 0 ? chosenImage : "https://creatokia-rs-test.s3.eu-central-1.amazonaws.com/backend/crt_socialMedia_fallbackImage.jpg",
        alternativeText: "",
        height: "",
        width: ""
    };
    var ref35, ref36, ref37;
    var strapiMeta = {
        metaTagDescription: newsDesc !== null && newsDesc !== void 0 ? newsDesc : meta.description,
        metaTagKeywords: (ref35 = newsCE === null || newsCE === void 0 ? void 0 : (ref19 = newsCE.news) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.detail) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.metaData) === null || ref21 === void 0 ? void 0 : ref21.keywords) !== null && ref35 !== void 0 ? ref35 : meta.keywords,
        metaTagTitle: newsTitle !== null && newsTitle !== void 0 ? newsTitle : meta.title,
        metaTagCanonical: (ref36 = newsCE === null || newsCE === void 0 ? void 0 : (ref22 = newsCE.news) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.detail) === null || ref23 === void 0 ? void 0 : ref23.canonical) !== null && ref36 !== void 0 ? ref36 : meta.canonical,
        metaOgTitle: newsTitle !== null && newsTitle !== void 0 ? newsTitle : meta.ogTitle,
        metaOgDescription: newsDesc !== null && newsDesc !== void 0 ? newsDesc : meta.ogDescription,
        MetaOgImage: metaOgImage,
        metaTwitterTitle: newsTitle !== null && newsTitle !== void 0 ? newsTitle : meta.twitterTitle,
        metaTwitterDescription: newsDesc !== null && newsDesc !== void 0 ? newsDesc : meta.twitterDescription,
        metaTwitterImage: (ref37 = metaImage === null || metaImage === void 0 ? void 0 : metaImage.publicUrl) !== null && ref37 !== void 0 ? ref37 : (ref24 = meta.twitterImage) === null || ref24 === void 0 ? void 0 : ref24.publicUrl,
        metaTwitterSite: meta.twitterCard,
        metaNoFollow: (ref25 = meta.robots) === null || ref25 === void 0 ? void 0 : ref25.noFollow,
        metaNoIndex: (ref26 = meta.robots) === null || ref26 === void 0 ? void 0 : ref26.noIndex
    };
    var progressReaderCollect = false;
    var progressReader;
    var progressReaderItems = [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Worker, {
        workerUrl: "https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n                typo-page\n                ".concat(inverted ? "".concat((typo_page_module_default()).inverted, " inverted") : "", "\n                ").concat((data === null || data === void 0 ? void 0 : (ref27 = data.creatokia) === null || ref27 === void 0 ? void 0 : ref27.page) ? (typo_page_module_default())["".concat(data === null || data === void 0 ? void 0 : (ref28 = data.creatokia) === null || ref28 === void 0 ? void 0 : ref28.page)] : "", "\n            "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
                    forStaticPage: true,
                    pageType: type,
                    availableLanguages: nextLocalizations,
                    typoService: typoService
                }),
                stage: stageElement ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (typo_page_module_default())["stage-container"],
                    children: stageElement
                }) : undefined,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {
                    typoService: typoService
                }),
                children: pageContent && pageContent.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (typo_page_module_default())["typo-page"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                            tags: strapiMeta,
                            articlePageType: type,
                            isTypoPage: true
                        }),
                        Object.keys(pageContent).map(function(key) {
                            var element = pageContent[key];
                            if (element.type === "progressReaderStart" || element.type === "progressReaderEnd" || progressReaderCollect) {
                                if (element.type === "progressReaderStart") {
                                    setProgressReaderCollect(true);
                                    setProgressReader(element.content);
                                } else if (element.type === "progressReaderEnd" || key >= pageContent.length) {
                                    var items = progressReaderItems;
                                    setProgressReaderCollect(false);
                                    setProgressReaderItems([]);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressReader, {
                                            items: items,
                                            maxWidth: progressReader.maxWidth,
                                            withoutBar: progressReader.withoutBar
                                        })
                                    }, key);
                                } else {
                                    setProgressReaderItems(_toConsumableArray(progressReaderItems).concat([
                                        element
                                    ]));
                                }
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: typoService.createContentElement(element)
                                }, key);
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (typo_page_module_default()).loading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (typo_page_module_default())["loading-label"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                                    inverted: inverted,
                                    children: "Loading"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (typo_page_module_default())["loading-content"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (typo_page_module_default())["loading-dot-elastic"]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: typeof typoContent == "number" && /*#__PURE__*/ (0,jsx_runtime.jsx)(error_page/* default */.Z, {})
                    })
                })
            })
        })
    });
};
TypoPage.dataHooks = [
    useTypoContent_hook/* useTypoContent */.f,
    useErrorPage_hook/* useErrorPage */.v
].concat(_toConsumableArray(_app["default"].dataHooks), _toConsumableArray(contact_form/* default.dataHooks */.Z.dataHooks), _toConsumableArray(header_footer_wrapper/* HeaderFooterWrapper.dataHooks */.u.dataHooks), _toConsumableArray(article_page_temp_header/* ArticlePageTempHeader.dataHooks */.H.dataHooks), _toConsumableArray(register_form_light/* RegisterFormLight.dataHooks */.c.dataHooks), _toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));


/***/ }),

/***/ 46076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","reading-progress-container":"progress_reader_reading-progress-container__LxIx6","reading-progress":"progress_reader_reading-progress__y2Rvg","width-small":"progress_reader_width-small__w9Foa","width-medium":"progress_reader_width-medium___44cm","width-large":"progress_reader_width-large__n_Y4r"};

/***/ }),

/***/ 10995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","typo-page":"typo-page_typo-page__ZOT5T","small":"typo-page_small__bdrQP","large":"typo-page_large__otDlv","center":"typo-page_center__B7pMS","left":"typo-page_left__o6P57","right":"typo-page_right__85hIY","inverted":"typo-page_inverted__jN6oO","loading":"typo-page_loading__S2KTq","loading-label":"typo-page_loading-label__eml_J","loading-content":"typo-page_loading-content__Wqpej","loading-dot-elastic":"typo-page_loading-dot-elastic__KzYXY","dotElastic":"typo-page_dotElastic__bJhq9","dotElasticBefore":"typo-page_dotElasticBefore__oo2D1","dotElasticAfter":"typo-page_dotElasticAfter__3ZFa1","stage-container":"typo-page_stage-container__8iVWU","news":"typo-page_news__kBK_m","fullwidth":"typo-page_fullwidth__163j6"};

/***/ })

}]);